export default __webpack_public_path__ + "/dist/images/7362993.png";